import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SETTINGS_MODULE } from '../../configs/moduleNames';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const SET_COMPASS = '_SET_COMPASS';
export const SET_GPS_MOD = '_SET_GPS_MOD';
export const LOAD_DATE_SETTINGS = '_LOAD_DATE_SETTINGS';
export const LOAD_PRESETS = '_LOAD_PRESETS';
export const SAVE_PRESET = '_SAVE_PRESET';
export const CREATE_PRESET = '_CREATE_PRESET';
export const DELETE_PRESET = '_DELETE_PRESET';
export const LOAD_PRESETS_COLLAGE = '_LOAD_PRESETS_COLLAGE';
export const SAVE_EXPORT = '_SAVE_EXPORT';
export const UPDATE_EXPORT = '_UPDATE_EXPORT';
export const DELETE_EXPORT = '_DELETE_EXPORT';
export const LOAD_EXPORT = '_LOAD_EXPORT';
export const LOAD_USER_LIST = '_LOAD_USER_LIST';
export const SAVE_USER = '_SAVE_USER';
export const DELETE_USER = '_DELETE_USER';
export const LOAD_ROLE_LIST = '_LOAD_ROLE_LIST';
export const SAVE_ROLE = '_SAVE_ROLE';
export const CREATE_ROLE = '_CREATE_ROLE';
export const DELETE_ROLE = '_DELETE_ROLE';
export const CREATE_USER = '_CREATE_USER';
export const LOAD_USER_ACTION = '_LOAD_USER_ACTION';
export const LOAD_WANTED_LIST = '_LOAD_WANTED_LIST';
export const ADD_LPN_TO_WANTED = '_ADD_LPN_TO_WANTED';
export const DELETE_FROM_WANTED = '_DELETE_FROM_WANTED';
export const IMPORT_LPN_FILE = '_IMPORT_LPN_FILE';
export const LOAD_CAMERAS = '_LOAD_CAMERAS';
export const CREATE_CAMERA = '_CREATE_CAMERA';
export const SAVE_CAMERA = '_SAVE_CAMERA';
export const DELETE_CAMERA = '_DELETE_CAMERA';
export const UPDATE_CAMERA = '_UPDATE_CAMERA';
export const SET_PTZ = '_SET_PTZ';
export const ADD_TO_WHITE_LIST = '_ADD_TO_WHITE_LIST';
export const LOAD_WHITE_LIST = '_LOAD_WHITE_LIST';
export const DELETE_FROM_WHITE_LIST = '_DELETE_FROM_WHITE_LIST';
export const IMPORT_WHITE_LIST = '_IMPORT_WHITE_LIST';

export const LOAD_VIOLATION_LIST = '_LOAD_VIOLATION_LIST';
export const ADD_TO_VIOLATION_LIST = '_ADD_TO_VIOLATION_LIST';
export const DELETE_FROM_VIOLATION_LIST = '_DELETE_FROM_VIOLATION_LIST';
export const IMPORT_VIOLATION_LIST = '_IMPORT_VIOLATION_LIST';
export const CALIBRATE_CAMERA = '_CALIBRATE_CAMERA';
export const GET_DEFAULT_COLLAGE = '_GET_DEFAULT_COLLAGE';
export const NODE_EVENT = '_NODE_EVENT';
export const SAVE_DATE_SETTINGS = '_SAVE_DATE_SETTINGS';
export const LOAD_ARCHIVE_SETTINGS = '_LOAD_ARCHIVE_SETTINGS';
export const SAVE_ARCHIVE_SETTINGS = '_SAVE_ARCHIVE_SETTINGS';
export const LOAD_ANALYSTS_SETTINGS = '_LOAD_ANALYSTS_SETTINGS';
export const SAVE_ANALYSTS_SETTINGS = '_SAVE_ANALYSTS_SETTINGS';
export const LOAD_DATE_STATUS = '_LOAD_DATE_STATUS';
export const LOAD_GENERAL_SETTINGS = '_LOAD_GENERAL_SETTINGS';
export const SAVE_GENERAL_SETTINGS = '_SAVE_GENERAL_SETTINGS';

export const setCompass = createDeferredAction(SETTINGS_MODULE + SET_COMPASS);
export const setCompassSuccessful = createAction(SETTINGS_MODULE + SET_COMPASS + SUCCESSFUL);
export const setCompassFailed = createAction(SETTINGS_MODULE + SET_COMPASS + FAILED);

export const setGpsMod = createDeferredAction(SETTINGS_MODULE + SET_GPS_MOD);
export const setGpsModSuccessful = createAction(SETTINGS_MODULE + SET_GPS_MOD + SUCCESSFUL);
export const setGpsModFailed = createAction(SETTINGS_MODULE + SET_GPS_MOD + FAILED);

export const loadPresets = createDeferredAction(SETTINGS_MODULE + LOAD_PRESETS);
export const loadPresetsSuccessful = createAction(SETTINGS_MODULE + LOAD_PRESETS + SUCCESSFUL);
export const loadPresetsFailed = createAction(SETTINGS_MODULE + LOAD_PRESETS + FAILED);

export const savePresets = createDeferredAction(SETTINGS_MODULE + SAVE_PRESET);
export const savePresetsSuccessful = createAction(SETTINGS_MODULE + SAVE_PRESET + SUCCESSFUL);
export const savePresetsFailed = createAction(SETTINGS_MODULE + SAVE_PRESET + FAILED);

export const deletePreset = createDeferredAction(SETTINGS_MODULE + DELETE_PRESET);
export const deletePresetSuccessful = createAction(SETTINGS_MODULE + DELETE_PRESET + SUCCESSFUL);
export const deletePresetFailed = createAction(SETTINGS_MODULE + DELETE_PRESET + FAILED);

export const loadPresetsCollage = createDeferredAction(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE);
export const loadPresetsCollageBegin = createDeferredAction(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE + BEGIN);
export const loadPresetsCollageSuccessful = createAction(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE + SUCCESSFUL);
export const loadPresetsCollageFailed = createAction(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE + FAILED);

export const createPreset = createDeferredAction(SETTINGS_MODULE + CREATE_PRESET);
export const createPresetSuccessful = createAction(SETTINGS_MODULE + CREATE_PRESET + SUCCESSFUL);
export const createPresetFailed = createAction(SETTINGS_MODULE + CREATE_PRESET + FAILED);

export const saveExport = createDeferredAction(SETTINGS_MODULE + SAVE_EXPORT);
export const saveExportSuccessful = createAction(SETTINGS_MODULE + SAVE_EXPORT + SUCCESSFUL);
export const saveExportFailed = createAction(SETTINGS_MODULE + SAVE_EXPORT + FAILED);

export const updateExport = createDeferredAction(SETTINGS_MODULE + UPDATE_EXPORT);
export const updateExportSuccessful = createAction(SETTINGS_MODULE + UPDATE_EXPORT + SUCCESSFUL);
export const updateExportFailed = createAction(SETTINGS_MODULE + UPDATE_EXPORT + FAILED);

export const deleteExport = createDeferredAction(SETTINGS_MODULE + DELETE_EXPORT);
export const deleteExportSuccessful = createAction(SETTINGS_MODULE + DELETE_EXPORT + SUCCESSFUL);
export const deleteExportFailed = createAction(SETTINGS_MODULE + DELETE_EXPORT + FAILED);

export const loadExport = createDeferredAction(SETTINGS_MODULE + LOAD_EXPORT);
export const loadExportSuccessful = createAction(SETTINGS_MODULE + LOAD_EXPORT + SUCCESSFUL);
export const loadExportFailed = createAction(SETTINGS_MODULE + LOAD_EXPORT + FAILED);

export const loadUserList = createDeferredAction(SETTINGS_MODULE + LOAD_USER_LIST);
export const loadUserListSuccessful = createAction(SETTINGS_MODULE + LOAD_USER_LIST + SUCCESSFUL);
export const loadUserListFailed = createAction(SETTINGS_MODULE + LOAD_USER_LIST + FAILED);

export const loadUserAction = createDeferredAction(SETTINGS_MODULE + LOAD_USER_ACTION);
export const loadUserActionSuccessful = createAction(SETTINGS_MODULE + LOAD_USER_ACTION + SUCCESSFUL);
export const loadUserActionFailed = createAction(SETTINGS_MODULE + LOAD_USER_ACTION + FAILED);

export const createUser = createDeferredAction(SETTINGS_MODULE + CREATE_USER);
export const createUserSuccessful = createAction(SETTINGS_MODULE + CREATE_USER + SUCCESSFUL);
export const createUserFailed = createAction(SETTINGS_MODULE + CREATE_USER + FAILED);

export const saveUser = createDeferredAction(SETTINGS_MODULE + SAVE_USER);
export const saveUserSuccessful = createAction(SETTINGS_MODULE + SAVE_USER + SUCCESSFUL);
export const saveUserFailed = createAction(SETTINGS_MODULE + SAVE_USER + FAILED);

export const deleteUser = createDeferredAction(SETTINGS_MODULE + DELETE_USER);
export const deleteUserSuccessful = createAction(SETTINGS_MODULE + DELETE_USER + SUCCESSFUL);
export const deleteUserFailed = createAction(SETTINGS_MODULE + DELETE_USER + FAILED);

export const loadRoleList = createDeferredAction(SETTINGS_MODULE + LOAD_ROLE_LIST);
export const loadRoleListSuccessful = createAction(SETTINGS_MODULE + LOAD_ROLE_LIST + SUCCESSFUL);
export const loadRoleListFailed = createAction(SETTINGS_MODULE + LOAD_ROLE_LIST + FAILED);

export const saveRole = createDeferredAction(SETTINGS_MODULE + SAVE_ROLE);
export const saveRoleSuccessful = createAction(SETTINGS_MODULE + SAVE_ROLE + SUCCESSFUL);
export const saveRoleFailed = createAction(SETTINGS_MODULE + SAVE_ROLE + FAILED);

export const createRole = createDeferredAction(SETTINGS_MODULE + CREATE_ROLE);
export const createRoleSuccessful = createAction(SETTINGS_MODULE + CREATE_ROLE + SUCCESSFUL);
export const createRoleFailed = createAction(SETTINGS_MODULE + CREATE_ROLE + FAILED);

export const deleteRole = createDeferredAction(SETTINGS_MODULE + DELETE_ROLE);
export const deleteRoleSuccessful = createAction(SETTINGS_MODULE + DELETE_ROLE + SUCCESSFUL);
export const deleteRoleFailed = createAction(SETTINGS_MODULE + DELETE_ROLE + FAILED);

export const loadWantedList = createDeferredAction(SETTINGS_MODULE + LOAD_WANTED_LIST);
export const loadWantedListSuccessful = createAction(SETTINGS_MODULE + LOAD_WANTED_LIST + SUCCESSFUL);
export const loadWantedListFailed = createAction(SETTINGS_MODULE + LOAD_WANTED_LIST + FAILED);

export const addLPNToWanted = createDeferredAction(SETTINGS_MODULE + ADD_LPN_TO_WANTED);
export const addLPNToWantedSuccessful = createAction(SETTINGS_MODULE + ADD_LPN_TO_WANTED + SUCCESSFUL);
export const addLPNToWantedFailed = createAction(SETTINGS_MODULE + ADD_LPN_TO_WANTED + FAILED);

export const deleteFromWanted = createDeferredAction(SETTINGS_MODULE + DELETE_FROM_WANTED);
export const deleteFromWantedSuccessful = createAction(SETTINGS_MODULE + DELETE_FROM_WANTED + SUCCESSFUL);
export const deleteFromWantedFailed = createAction(SETTINGS_MODULE + DELETE_FROM_WANTED + FAILED);

export const importLPNFile = createDeferredAction(SETTINGS_MODULE + IMPORT_LPN_FILE);
export const importLPNFileSuccessful = createAction(SETTINGS_MODULE + IMPORT_LPN_FILE + SUCCESSFUL);
export const importLPNFileFailed = createAction(SETTINGS_MODULE + IMPORT_LPN_FILE + FAILED);

export const loadCameras = createDeferredAction(SETTINGS_MODULE + LOAD_CAMERAS);
export const loadCamerasSuccessful = createAction(SETTINGS_MODULE + LOAD_CAMERAS + SUCCESSFUL);
export const loadCamerasFailed = createAction(SETTINGS_MODULE + LOAD_CAMERAS + FAILED);

export const createCamera = createDeferredAction(SETTINGS_MODULE + CREATE_CAMERA);
export const createCameraSuccessful = createAction(SETTINGS_MODULE + CREATE_CAMERA + SUCCESSFUL);
export const createCameraFailed = createAction(SETTINGS_MODULE + CREATE_CAMERA + FAILED);

export const saveCamera = createDeferredAction(SETTINGS_MODULE + SAVE_CAMERA);
export const saveCameraSuccessful = createAction(SETTINGS_MODULE + SAVE_CAMERA + SUCCESSFUL);
export const saveCameraFailed = createAction(SETTINGS_MODULE + SAVE_CAMERA + FAILED);

export const deleteCamera = createDeferredAction(SETTINGS_MODULE + DELETE_CAMERA);
export const deleteCameraSuccessful = createAction(SETTINGS_MODULE + DELETE_CAMERA + SUCCESSFUL);
export const deleteCameraFailed = createAction(SETTINGS_MODULE + DELETE_CAMERA + FAILED);

export const calibrateCamera = createDeferredAction(SETTINGS_MODULE + CALIBRATE_CAMERA);
export const calibrateCameraSuccessful = createAction(SETTINGS_MODULE + CALIBRATE_CAMERA + SUCCESSFUL);
export const calibrateCameraFailed = createAction(SETTINGS_MODULE + CALIBRATE_CAMERA + FAILED);

export const updateCamera = createDeferredAction(SETTINGS_MODULE + UPDATE_CAMERA);
export const updateCameraSuccessful = createAction(SETTINGS_MODULE + UPDATE_CAMERA + SUCCESSFUL);
export const updateCameraFailed = createAction(SETTINGS_MODULE + UPDATE_CAMERA + FAILED);

export const nodeEvent = createDeferredAction(SETTINGS_MODULE + NODE_EVENT);
export const nodeEventSuccessful = createAction(SETTINGS_MODULE + NODE_EVENT + SUCCESSFUL);
export const nodeEventFailed = createAction(SETTINGS_MODULE + NODE_EVENT + FAILED);

export const setPTZ = createDeferredAction(SETTINGS_MODULE + SET_PTZ);
export const setPTZSuccessful = createAction(SETTINGS_MODULE + SET_PTZ + SUCCESSFUL);
export const setPTZFailed = createAction(SETTINGS_MODULE + SET_PTZ + FAILED);

export const loadWhiteList = createDeferredAction(SETTINGS_MODULE + LOAD_WHITE_LIST);
export const loadWhiteListSuccessful = createAction(SETTINGS_MODULE + LOAD_WHITE_LIST + SUCCESSFUL);
export const loadWhiteListFailed = createAction(SETTINGS_MODULE + LOAD_WHITE_LIST + FAILED);

export const addToWhiteList = createDeferredAction(SETTINGS_MODULE + ADD_TO_WHITE_LIST);
export const addToWhiteListSuccessful = createAction(SETTINGS_MODULE + ADD_TO_WHITE_LIST + SUCCESSFUL);
export const addToWhiteListFailed = createAction(SETTINGS_MODULE + ADD_TO_WHITE_LIST + FAILED);

export const deleteFromWhiteList = createDeferredAction(SETTINGS_MODULE + DELETE_FROM_WHITE_LIST);
export const deleteFromWhiteListSuccessful = createAction(SETTINGS_MODULE + DELETE_FROM_WHITE_LIST + SUCCESSFUL);
export const deleteFromWhiteListFailed = createAction(SETTINGS_MODULE + DELETE_FROM_WHITE_LIST + FAILED);

export const importWhiteList = createDeferredAction(SETTINGS_MODULE + IMPORT_WHITE_LIST);
export const importWhiteListSuccessful = createAction(SETTINGS_MODULE + IMPORT_WHITE_LIST + SUCCESSFUL);
export const importWhiteListFailed = createAction(SETTINGS_MODULE + IMPORT_WHITE_LIST + FAILED);

export const loadViolationList = createDeferredAction(SETTINGS_MODULE + LOAD_VIOLATION_LIST);
export const loadViolationListSuccessful = createAction(SETTINGS_MODULE + LOAD_VIOLATION_LIST + SUCCESSFUL);
export const loadViolationListFailed = createAction(SETTINGS_MODULE + LOAD_VIOLATION_LIST + FAILED);

export const addToViolationList = createDeferredAction(SETTINGS_MODULE + ADD_TO_VIOLATION_LIST);
export const addToViolationListSuccessful = createAction(SETTINGS_MODULE + ADD_TO_VIOLATION_LIST + SUCCESSFUL);
export const addToViolationListFailed = createAction(SETTINGS_MODULE + ADD_TO_VIOLATION_LIST + FAILED);

export const deleteFromViolationList = createDeferredAction(SETTINGS_MODULE + DELETE_FROM_VIOLATION_LIST);
export const deleteFromViolationListSuccessful = createAction(SETTINGS_MODULE + DELETE_FROM_VIOLATION_LIST + SUCCESSFUL);
export const deleteFromViolationListFailed = createAction(SETTINGS_MODULE + DELETE_FROM_VIOLATION_LIST + FAILED);

export const importViolationList = createDeferredAction(SETTINGS_MODULE + IMPORT_VIOLATION_LIST);
export const importViolationListSuccessful = createAction(SETTINGS_MODULE + IMPORT_VIOLATION_LIST + SUCCESSFUL);
export const importViolationListFailed = createAction(SETTINGS_MODULE + IMPORT_VIOLATION_LIST + FAILED);

export const getDefaultCollage = createDeferredAction(SETTINGS_MODULE + GET_DEFAULT_COLLAGE);
export const getDefaultCollageSuccessful = createAction(SETTINGS_MODULE + GET_DEFAULT_COLLAGE + SUCCESSFUL);
export const getDefaultCollageFailed = createAction(SETTINGS_MODULE + GET_DEFAULT_COLLAGE + FAILED);

export const loadDateSettings = createDeferredAction(SETTINGS_MODULE + LOAD_DATE_SETTINGS);
export const loadDateSettingsSuccessful = createAction(SETTINGS_MODULE + LOAD_DATE_SETTINGS + SUCCESSFUL);
export const loadDateSettingsFailed = createAction(SETTINGS_MODULE + LOAD_DATE_SETTINGS + FAILED);

export const loadDateStatus = createDeferredAction(SETTINGS_MODULE + LOAD_DATE_STATUS);
export const loadDateStatusSuccessful = createAction(SETTINGS_MODULE + LOAD_DATE_STATUS + SUCCESSFUL);
export const loadDateStatusFailed = createAction(SETTINGS_MODULE + LOAD_DATE_STATUS + FAILED);

export const saveDateSettings = createDeferredAction(SETTINGS_MODULE + SAVE_DATE_SETTINGS);
export const saveDateSettingsSuccessful = createAction(SETTINGS_MODULE + SAVE_DATE_SETTINGS + SUCCESSFUL);
export const saveDateSettingsFailed = createAction(SETTINGS_MODULE + SAVE_DATE_SETTINGS + FAILED);

export const loadArchiveSettings = createDeferredAction(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS);
export const loadArchiveSettingsSuccessful = createAction(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS + SUCCESSFUL);
export const loadArchiveSettingsFailed = createAction(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS + FAILED);

export const saveArchiveSettings = createDeferredAction(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS);
export const saveArchiveSettingsSuccessful = createAction(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS + SUCCESSFUL);
export const saveArchiveSettingsFailed = createAction(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS + FAILED);

export const loadAnalystsSettings = createDeferredAction(SETTINGS_MODULE + LOAD_ANALYSTS_SETTINGS);
export const loadAnalystsSettingsSuccessful = createAction(SETTINGS_MODULE + LOAD_ANALYSTS_SETTINGS + SUCCESSFUL);
export const loadAnalystsSettingsFailed = createAction(SETTINGS_MODULE + LOAD_ANALYSTS_SETTINGS + FAILED);

export const saveAnalystsSettings = createDeferredAction(SETTINGS_MODULE + SAVE_ANALYSTS_SETTINGS);
export const saveAnalystsSettingsSuccessful = createAction(SETTINGS_MODULE + SAVE_ANALYSTS_SETTINGS + SUCCESSFUL);
export const saveAnalystsSettingsFailed = createAction(SETTINGS_MODULE + SAVE_ANALYSTS_SETTINGS + FAILED);

export const loadGeneralSettings = createDeferredAction(SETTINGS_MODULE + LOAD_GENERAL_SETTINGS);
export const loadGeneralSettingsSuccessful = createAction(SETTINGS_MODULE + LOAD_GENERAL_SETTINGS + SUCCESSFUL);
export const loadGeneralSettingsFailed = createAction(SETTINGS_MODULE + LOAD_GENERAL_SETTINGS + FAILED);

export const saveGeneralSettings = createDeferredAction(SETTINGS_MODULE + SAVE_GENERAL_SETTINGS);
export const saveGeneralSettingsSuccessful = createAction(SETTINGS_MODULE + SAVE_GENERAL_SETTINGS + SUCCESSFUL);
export const saveGeneralSettingsFailed = createAction(SETTINGS_MODULE + SAVE_GENERAL_SETTINGS + FAILED);
